import React, { useState } from 'react'
import { Header, TableWrapper, TableSection, SearchWrapper } from '../../DashBoard/dashBoardStyled'
//table
import { Table } from 'reactstrap';
import { MdKeyboardBackspace } from "react-icons/md";

const ReferredUsersList = ({ tableData, updateActivePageFunction }) => {
    const [headerArr, setHeaderArr] = useState([
        { title: 'ID', },
        { title: 'Email', }
    ])

    return (
        <TableWrapper>
            <MdKeyboardBackspace style={{ width: '28px', height: '28px', position: 'relative', left: '12px', top: '8px', cursor: 'pointer' }}
                onClick={() => updateActivePageFunction('ReferralReport')} />
            <Header>
                <h3>Referred Users</h3>
            </Header>
            <TableSection>
                <Table responsive>
                    <thead>
                        <tr>
                            {headerArr.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            tableData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.id}</td>
                                    <td>{items.emailId}</td>
                                </tr>
                            ))}
                    </tbody>
                </Table>
            </TableSection>

        </TableWrapper>

    )
};

export default ReferredUsersList;



